// src/utils/fabricSetup.js

/**
 * Snapshot current Fabric state with canvas dimensions for normalization.
 */
export function serializeForPersist(fabric, meta = {}) {
  if (!fabric) return null;
  const canvasWidth  = fabric.getWidth();
  const canvasHeight = fabric.getHeight();
  return {
    fabricJson: fabric.toJSON(),
    meta: {
      canvasWidth,
      canvasHeight,
      baseScale: typeof meta.baseScale === 'number' ? meta.baseScale : 1,
    },
  };
}

/**
 * Load saved JSON and scale objects to fit current canvas size.
 * This keeps handwriting looking identical regardless of zoom/device width.
 */
export function loadAndNormalize(fabric, saved) {
  return new Promise((resolve) => {
    if (!fabric || !saved || !saved.fabricJson || !saved.meta) return resolve(false);

    const newW = fabric.getWidth();
    const newH = fabric.getHeight();
    const oldW = saved.meta.canvasWidth || newW;
    const oldH = saved.meta.canvasHeight || newH;

    const sx = newW / oldW;
    const sy = newH / oldH;

    fabric.loadFromJSON(saved.fabricJson, () => {
      // Scale every object (including paths)
      fabric.getObjects().forEach((obj) => {
        // If strokeUniform was enabled elsewhere, keep it; otherwise scale stroke with the object
        if (obj.set) {
          obj.set({
            left: obj.left * sx,
            top: obj.top * sy,
            scaleX: (obj.scaleX || 1) * sx,
            scaleY: (obj.scaleY || 1) * sy,
          });
          obj.setCoords();
        }
      });
      fabric.renderAll();
      resolve(true);
    });
  });
}
